<script lang="ts">
    import {getInjector} from 'core/svelte-context/context';
    import LoginService from '../../login/login.service';

    export let additionalClasses = '';

    const injector = getInjector();
    const loginService = injector.getByToken<LoginService>(LoginService.serviceName);
</script>

<template>
    <!-- svelte-ignore a11y-invalid-attribute because javascript:void(0) accessibility -->
    <a class="{additionalClasses}" href="javascript:void(0)" on:click={() => loginService.goLogged('/users/current')}>
        <slot></slot>
    </a>
</template>